const ProducsData = [
  {
    installments: "em até 3x no cartão",
    type: "Pré treino BOPE",
    productBrand: "Black-Skull",
    description: "150g",
    priceWithoutDiscount: "100.00",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/PreWorkout/pre_workout_bope_blackskull_150g.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Pré treino Crack",
    productBrand: "Demons-Lab",
    description: "300g",
    priceWithoutDiscount: "100.00",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/PreWorkout/pre_workout_crack_300g.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Pré treino",
    productBrand: "Diabo Verde",
    description: "300g",
    priceWithoutDiscount: "100.00",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/PreWorkout/pre_workout_diabo_verde_300g.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Pré treino Psicho Killer ",
    productBrand: "Demons-Lab",
    description: "294g",
    priceWithoutDiscount: "100.00",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/PreWorkout/pre_workout_psycho_killer_294g.png"),
  },

  {
    installments: "em até 3x no cartão",
    type: "Pré treino Égide",
    productBrand: "Max titanium",
    description: "150g",
    priceWithoutDiscount: "100.00",
    quantity: "9",
    imageSrc: require("../../assets/ImgProducts/PreWorkout/pre_workout_egide_max_titanium_150g.png"),
  },
];

export default ProducsData;
